import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { TemporaryClosure, WorkingDays } from '@pedix-workspace/utils';
import { ModalDialogComponent, ModalDialogService } from '@pedix-workspace/angular-ui-modal';
import { IconBanComponent } from '@pedix-workspace/angular-ui-icons';
import { WorkingHoursMessageDialogComponent } from '@pedix-workspace/pedixapp-shared-catalog';
import { format } from 'date-fns';

@Component({
  selector: 'app-working-hours-message',
  templateUrl: './working-hours-message.component.html',
  styleUrls: ['./working-hours-message.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconBanComponent],
})
export class WorkingHoursMessageComponent implements AfterViewInit {
  private t = inject(TranslocoService);
  private modalDialogService = inject(ModalDialogService);

  @ViewChild('message') messageElement: ElementRef<HTMLElement>;

  @Input() isClosed: boolean;
  @Input() isAboutToClose: boolean;
  @Input() isTemporaryClosed: boolean;
  @Input() isInventoryBlocked = false;
  @Input() workingDays: WorkingDays | null;
  @Input() temporaryClosure: TemporaryClosure;

  hasMessageOverflow = signal(false);

  get closureMessage() {
    if (this.isInventoryBlocked) {
      return this.t.translate('workingHours.inventoryClosedDescription');
    }
    return this.temporaryClosureMessage;
  }

  get temporaryClosureMessage() {
    if (this.temporaryClosure?.message) {
      return this.temporaryClosure.message;
    }
    if (this.temporaryClosure?.to) {
      const returnDate = format(this.temporaryClosure?.to, 'dd/MM/yy');

      return this.t.translate('workingHours.temporaryClosedDescription', { returnDate });
    }
    return '';
  }

  ngAfterViewInit() {
    if (this.messageElement?.nativeElement) {
      const element = this.messageElement.nativeElement;

      this.hasMessageOverflow.set(element.scrollHeight > element.clientHeight);
    }
  }

  displayWorkingHours() {
    this.modalDialogService.attachDialog(WorkingHoursMessageDialogComponent).open(this.workingDays);
  }
}
